import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { DeviceRosterResponse } from '@/api/handlers/resources/auth/responses';
import type { ApiResponse } from '@/api/handlers/responses';

/**
 * Branch roster for the seller-select screen. Carries the device token (the
 * request interceptor attaches it from the endpoint path). `staleTime` is 0 so a
 * roster change (a seller added/removed by an admin) shows on the next visit.
 */
export const useDeviceRosterQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<DeviceRosterResponse>>({
        queryKey: [apiClient.auth.getDeviceUsers.name],
        queryFn: () => apiClient.auth.getDeviceUsers(),
        enabled,
        staleTime: 0,
    });
};
